import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LocalService } from "app/services/local.service";
import * as CryptoJS from "crypto-js";
import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
const myMapKeys = environment.mapKeys;
const mapKeyIndex = Math.floor(Math.random() * myMapKeys.length);
var key = myMapKeys[mapKeyIndex];
@Injectable()
export class PageService {
  expireAlert = 0;
  clickedUserId = "";
  projectName =
    localStorage.getItem("client") &&
    JSON.parse(localStorage.getItem("client")) &&
    JSON.parse(localStorage.getItem("client"))["apiUrl"]
      ? JSON.parse(localStorage.getItem("client"))["projectName"]
      : environment.projectName;

  apiUrl = "https://fposervice.marketplace.cruzotec.com";

  // localStorage.getItem("client") &&
  // JSON.parse(localStorage.getItem("client")) &&
  // JSON.parse(localStorage.getItem("client"))["apiUrl"]
  //   ? JSON.parse(localStorage.getItem("client"))["apiUrl"]
  //   : environment.apiUrl;
  constructor(
    private http: HttpClient,
    public localService: LocalService,
    public modalService: NgbModal,
  ) {
    console.log(this.apiUrl);
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];

    } else {
      this.apiUrl = environment.apiUrl;
    }
    const data = JSON.parse(localStorage.getItem("client"));
    if (data && data["projectName"]) {
      this.projectName = data["projectName"];
    }
    if (data && data["apiUrl"]) {
      this.projectName = data["apiUrl"];
    }
  }
  getplatformConfig(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "aggregator/deliveryRadius/get", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  getplatformConfiglayout(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "aggregator/deliveryRadius/get?status=1", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  addHomeLayout(section): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "aggregator/deliveryRadius/addHomeLayout", section, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  getClientDetails(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http
      .post(environment.saasUrl + "clients/getClient", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  loginUser(data: any, apiUrl = this.apiUrl): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http
      .post(apiUrl + "api/auth/login", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  getCustomerRecord() {
    // console.log(this.toAuthJSON()['token'])
    return JSON.parse(this.localService.getJsonValue("customerRecord"));
  }
  createAccount(recordData): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http
      .post(this.apiUrl + "aggregator/createAccount", recordData, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  /**
   * Payment URL
   */
  checkPaymentCustomer(record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http
      .post(
        environment.paymentApiUrl + "paystack/customers/getCustomer",
        record,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  /**
   *
   * @param recordId
   */
  updatePassword(recordId, record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "customer/updateUserPassword/" + recordId, record, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  /**
   *
   * @param recordId
   */
  updateuserPassword(recordId, record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "deliveryPartner/updateUserPassword/" + recordId,
        record,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  showExpireAlert() {
    return this.expireAlert;
  }
  listPlans(params): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    return this.http
      .post(environment.paymentApiUrl + "paystack/plans/list", params, {
        headers: headers,
      })
      .map((respoonse) => respoonse)
      .toPromise();
  }
  registerCustomer(params): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    return this.http
      .post(environment.paymentApiUrl + "paystack/customers/create", params, {
        headers: headers,
      })
      .map((respoonse) => respoonse)
      .toPromise();
  }
  getPlanDetails(param): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    return this.http
      .get(environment.paymentApiUrl + "paystack/plans/getPlan/" + param, {
        headers: headers,
      })
      .map((respoonse) => respoonse)
      .toPromise();
  }
  subscribe(params): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    return this.http
      .post(environment.paymentApiUrl + "paystack/plans/subscribe", params, {
        headers: headers,
      })
      .map((respoonse) => respoonse)
      .toPromise();
  }
  initiaitateAuthorization(params): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    return this.http
      .post(
        environment.paymentApiUrl + "paystack/payments/initiateTransaction",
        params,
        {
          headers: headers,
        },
      )
      .map((respoonse) => respoonse)
      .toPromise();
  }
  getPaymentDetails(param): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    return this.http
      .post(
        environment.paymentApiUrl + "paystack/payments/payment/" + param,
        {},
        {
          headers: headers,
        },
      )
      .map((respoonse) => respoonse)
      .toPromise();
  }
  getSiteUrl() {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port;
    var currentSiteUrl = protocol + "//" + hostname;
    if (port != "80") {
      currentSiteUrl = protocol + "//" + hostname + ":" + port;
    }
    return currentSiteUrl;
  }
  getSubscriptionDetails(record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    return this.http
      .post(
        environment.paymentApiUrl + "paystack/plans/subscription/" + record,
        {},
        {
          headers: headers,
        },
      )
      .map((respoonse) => respoonse)
      .toPromise();
  }
  cancelSubscription(record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    return this.http
      .post(
        environment.paymentApiUrl + "paystack/plans/cancelSubscription",
        record,
        {
          headers: headers,
        },
      )
      .map((respoonse) => respoonse)
      .toPromise();
  }
  generateHash(data) {
    var passPhrase = null;
    let pfOutput = "";
    console.log(data);
    for (let key in data) {
      console.log(data[key]);
      if (data.hasOwnProperty(key)) {
        if (data[key] !== "") {
          const record =
            typeof data[key] === "string" ? data[key].trim() : data[key];
          pfOutput += `${key}=${encodeURIComponent(record).replace(
            /%20/g,
            " + ",
          )}&`;
        }
      }
    }
    // Remove last ampersand
    let getString = pfOutput.slice(0, -1);
    console.log(getString);
    if (passPhrase !== null) {
      getString += `&passphrase=${encodeURIComponent(passPhrase.trim()).replace(
        /%20/g,
        "+",
      )}`;
    }
    var md5String = CryptoJS.enc.Hex.stringify(CryptoJS.MD5(getString));
    return md5String;
    // return;
  }
  createPayment(paymentData): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    return this.http
      .post("https://sandbox.payfast.co.za​/eng/process", paymentData, {
        headers: headers,
      })
      .map((respoonse) => respoonse)
      .toPromise();
  }
  getOrders(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "order/getSellerOrders", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  updateOrderStatus(recordId, recordData): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "order/updateOrderStatus?orderStatusID=" + recordId,
        recordData,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  deleteOrderStatus(recordId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(
        this.apiUrl + "order/removeOrderStatus?orderStatusID=" + recordId,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  getOrderStatus(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "order/getOrderstatus", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  createOrderStatus(recordData): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "order/createOrderStatus", recordData, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  getInfo(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "aggregator/getInfo", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getServicesCategories(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/category/list", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  createServicesCategories(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/category/create", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  deleteSevicesSubCategory(id): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(this.apiUrl + "service/subCategory/delete/" + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  updateServiceCategory(data, categoryId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "service/category/update/" + categoryId, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getAllServicesList(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/listService", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  createTax(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/tax/create", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  updateTax(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/tax/update/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  deleteTax(id): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(this.apiUrl + "service/tax/delete/" + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  lisServicesTaxes(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/tax/list", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  createServiceCommissionConfig(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "service/commission/create", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getServiceCommissionConfig(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "service/commission/details",
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  createServiceprofessional(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/professional/create", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getServicesProf(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/professional/details", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  //Delete Service Professionals
  deleteServiceProf(id: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(this.apiUrl + "service/professional/delete/" + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  //update service professionals

  /**
   *
   * @param recordId
   */
  updateserviceProfPassword(recordId, record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "service/professional/updatepassword/" + recordId,
        record,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  //Auto Completetion Services Category

  getServicesCategoriesByName(term: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    // const search = {
    //   name: term,
    // };
    return this.http
      .post(
        this.apiUrl + "service/category/list",
        { name: term },
        {
          headers: headers,
        },
      )
      .pipe(map((response) => response["data"].slice(0, 10)));
  }

  //  service location

  createServicelocation(data: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/location/create", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  lisServicesLocations(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "service/location/list", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  deleteServiceLocation(id: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(this.apiUrl + "service/location/delete/" + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  /**
   *
   * COMMON POST METHOD FOR ALL SERVICES
   *
   * @param path extra path like 'order/createOrderStatus'
   * @param data desired data if any
   * @returns any
   */
  postMethod(path: string, data = {}): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http
      .post(this.apiUrl + path, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  /**
   *
   * COMMON PUT METHOD FOR ALL SERVICES
   *
   * @param path extra path like 'order/createOrderStatus'
   * @param data desired data if any
   * @returns any
   */
  putMethod(path: string, data = {}): Promise<any> {
  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem('token')}`
  });

  return this.http
    .put(this.apiUrl + path, data, {     // <-- CHANGE HERE
      headers: headers,
    })
    .map((response) => response)
    .toPromise();
}
  

  /**
   *
   * COMMON GET METHOD FOR ALL SERVICES
   *
   * @param path extra path like 'order/createOrderStatus'
   * @returns any
   */
  getMethod(path: string): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return (
      this.http
        .get(this.apiUrl + path, {
          headers: headers,
        })
        // this map supports rxjs-compact
        // npm install --save rxjs-compat
        .map((response: any) => response)
        .toPromise()
    );
  }

  /**
   *
   * COMMON PATCH METHOD FOR ALL SERVICES
   *
   * @param path extra path like 'order/createOrderStatus'
   * @returns any
   */
     patchMethod(id: string, data = {}): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      // "x-access-token": localStorage.getItem("token"),
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http
      .patch(this.apiUrl + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

   /**
   *
   * COMMON DELETE METHOD FOR ALL SERVICES
   *
   * @param path extra path like 'order/createOrderStatus'
   * @returns any
   */
     deleteMethod(id: string): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http
      .delete(this.apiUrl + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  /**
   *
   * COMMON SEARCH AND FILTER METHOD FOR ALL SERVICES
   *
   * @param path extra path like 'order/createOrderStatus'
   */
  searchFilter(path: string, searchData: any, key = "Data") {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http
      .post(this.apiUrl + path, searchData, { headers: headers })
      .pipe(map((response) => response[key].slice(0, 10)));
  }

  searchFilterGet(path: string, key = "data") {
  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem('token')}`
  });

  return this.http
    .get<any>(this.apiUrl + path, { headers })
    .pipe(
      map(response => response[key] || [])
    );
}

  /**
   * Getter and Setter for several components
   */

  get userid(): string {
    return this.clickedUserId;
  }
  set userid(value: string) {
    this.clickedUserId = value;
    // console.log(this.clickedUserId);
  }

  getMapAddress(lat, lng): Promise<any> {
    const url = "https://maps.googleapis.com/maps/api/geocode/json?";
    return this.http
      .get(`${url}latlng=${lat},${lng}&sensor=true&key=${key}`, {})
      .map((response: any) => response)
      .toPromise();
  }

  getcategorySubCategories(data: any) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/getSubCategoriesDetails", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getMenuList(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/menuLabel/list", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getAlltax(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/tax/list", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  roleList(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/listRole", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
    /**
   *
   * @param token It is the unique string for choose a seller
   */
  getSellerProfile(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "seller/profile", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
    deliveryDetails(Id): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "seller/listConfig/" + Id,
        {},
        {
          headers: headers,
        }
      )
      .map((response) => response)
      .toPromise();
  }
}
